import React, { useState } from "react";
import { updateTournamentLimits } from "services/tournamentService";
import * as Sentry from "@sentry/react";

const RegistrationLimit = ({ tournament }) => {
  const [limit, setLimit] = useState(tournament.registrationLimit || "");
  const [waitingListLimit, setWaitingListLimit] = useState(
    tournament.waitingListLimit || ""
  );
  const [isSaving, setIsSaving] = useState(false);

  const handleSubmit = async () => {
    if (limit < 0 || waitingListLimit < 0) {
      alert("Les valeurs doivent être positives.");
      return;
    }

    setIsSaving(true);
    try {
      await updateTournamentLimits(tournament.id, {
        registrationLimit: Number(limit),
        waitingListLimit: Number(waitingListLimit),
      });
      alert("Limites mises à jour !");
    } catch (error) {
      Sentry.captureException(error);
      alert(error.message);
    }
    setIsSaving(false);
  };

  return (
    <div className="mt-2 flex flex-wrap w-fit shadow-xl items-start justify-start gap-2 p-2">
      <div className="bg-gray-700 p-2 rounded-md flex flex-col items-start">
        <label className="text-white font-semibold block mb-1">
          Maximum d'inscriptions:
        </label>
        <div className="flex flex-row gap-2">
          <input
            type="number"
            min="0"
            value={waitingListLimit}
            onChange={(e) => setWaitingListLimit(e.target.value)}
            className="p-2 rounded-md text-black w-24"
          />
          <button
            onClick={handleSubmit}
            disabled={isSaving}
            className="px-4 py-2 bg-green-600 hover:bg-green-500 text-white rounded-lg font-semibold"
          >
            {isSaving ? "Enregistrement..." : "Sauvegarder"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationLimit;
